import { put } from 'redux-saga/effects'

import config from '../../Config'
import { MessagingCreators, TrackingCreators } from '../../../actions'

export function* participantLeave({ result }) {
  const { participant } = result
  if (participant) {
    yield put(
      MessagingCreators.displayMessage({
        name: participant.displayName,
        type: 'leave',
        delay: config.messageDelay,
      }),
    )
    if (participant.type === 'AGENT') {
      yield put(TrackingCreators.trackAgentEndedChat())
    }
  }
}

export default participantLeave
